import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import {
  faChartPie,
  faCircle,
  faCircleInfo,
  faCodeBranch,
  faFileImport,
  faFileLines,
  faGaugeHigh,
  faListCheck,
  faPenToSquare,
  faTable,
} from "@fortawesome/free-solid-svg-icons"

/**
 * The sidebar icon of each project section, by tab key (`?tab=<key>`).
 * Keys "8" (Provenance) and "9" (Data Checks) are listed ahead of the
 * branches that add those tabs, so they get their icon when they merge.
 */
export const PROJECT_SECTION_ICONS: Record<string, IconDefinition> = {
  "1": faCircleInfo, // General
  "2": faPenToSquare, // Questionnaire
  "3": faFileLines, // Documents
  "4": faFileImport, // Data Import
  "5": faChartPie, // Data Reporting
  "6": faGaugeHigh, // Dashboards
  "7": faTable, // Tables
  "8": faCodeBranch, // Provenance
  "9": faListCheck, // Data Checks
}

/** Icon for a section with no entry above. */
export const FALLBACK_SECTION_ICON: IconDefinition = faCircle
